import { type CapabilityKey, hasCapability } from '../../../common/capability/index.tsx';
import type { State } from '../../reducers/types.tsx';
import {
	getEntities,
	getIsIncrementPlanningBoard,
	projectTypeSelector,
} from '../software/software-selectors.tsx';

export const getCapability = (state: State) => (key: CapabilityKey) =>
	hasCapability(
		key,
		state.configuration.isCMPBoard,
		getIsIncrementPlanningBoard(state),
		getEntities(state).board.config.allFeatures,
		projectTypeSelector(state),
		state.configuration.isUserBoard,
	);
